import { AppPageLayout } from "@/components/common/AppPageLayout";
import ErrorPage from "@/components/pages/ErrorPage";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import { hooks as h } from "@/hooks";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const Profile = () => {
    const copy = useProfileCopy();
    h.useNav([{ route: { to: "/profile" }, label: copy.title }]);

    return (
        <AppPageLayout width="md" as="div" className="pt-6 md:py-8">
            <Outlet />
        </AppPageLayout>
    );
};

export const Route = createFileRoute("/_app/profile")({
    loader: async (opts) => {
        if (!opts.context?.auth.id) return;

        opts.context.queryClient.ensureQueryData(selectProfileByIdQueryOptions(opts.context.auth.id));
    },
    component: Profile,
    errorComponent: ({ error, reset }) => <ErrorPage title="Profile Error" error={error as Error} reset={reset} />,
});
